export const HeadingModule = () => {

    document.addEventListener('DOMContentLoaded', function () {


        let headingImageContainer = document.querySelectorAll('.heading__image');
        if(headingImageContainer.length > 0){
            addEventListener("resize", (event) => {
                setHeadingMargins();
            });
            setHeadingMargins();
        }
        function setHeadingMargins() {

            let headingTitles = document.querySelectorAll('.heading__title');
            let headingCtas = document.querySelectorAll('.heading__cta');
            let middleHeading = document.querySelector('.middle--heading');
            //let middleWidth = middleHeading.clientWidth;
            let screenWidth = window.innerWidth;
            //let titleWidth = 0;
            //let ctaWidth = 0;
            let margin = 0;
            let imageHeight = 0;
            let topPosition = 0;

            if (screenWidth > 1200) {
                if(screenWidth > 1728) {
                    screenWidth = 1728;
                }
                let imageWidth = screenWidth - 2 * 50;
                let dimensionForBlockHeight = 0.08041743;
                let dimensionForHeight = 0.499693063228975;
                //let dimensionForTitleWidth = 0.70902394;
                //let dimensionForCtaWidth = 0.73848987;
                let blockHeight = dimensionForBlockHeight * imageWidth;
                imageHeight = imageWidth * dimensionForHeight;
                margin = blockHeight - 50;
                if (screenWidth > 1400) {
                    topPosition = 50 - blockHeight;
                } else {
                    topPosition = 25 - blockHeight;
                }

                //titleWidth = imageWidth * dimensionForTitleWidth - (imageWidth - middleWidth) / 2;
                //ctaWidth = imageWidth * dimensionForCtaWidth - (imageWidth - middleWidth) / 2;


            } else if(screenWidth > 767){
                let imageWidth = screenWidth - 2 * 25;
                let dimensionForHeight = 0.51020408;
                imageHeight = imageWidth * dimensionForHeight;
            } else {
                let imageWidth = screenWidth;
                let dimensionForHeight = 1.06666667;
                imageHeight = imageWidth * dimensionForHeight;
            }


            for (let headingImage of headingImageContainer) {
                headingImage.style.height = imageHeight + 'px';
                if(headingTitles.length > 0){
                    if (screenWidth > 1200) {
                        let marginTop = -margin;
                        const section = headingImage.closest('.section');
                        const shortcutsNav = section
                            ? section.querySelector('.heading__shortcuts--lg .shortcuts-nav')
                            : null;

                        // Full-width image underlap would cover Schnellzugriffe when that
                        // column is taller than the title — only underlap the leftover,
                        // and keep 2rem clearance below the shortcuts.
                        if (shortcutsNav) {
                            const titleEl = section.querySelector('.heading__title');
                            const titleHeight = titleEl ? titleEl.offsetHeight : 0;
                            const shortcutsHeight = shortcutsNav.offsetHeight;
                            const rootFontSize = parseFloat(
                                getComputedStyle(document.documentElement).fontSize
                            );
                            const gap = rootFontSize * 4;
                            const underlap = Math.min(
                                margin,
                                Math.max(0, titleHeight - shortcutsHeight)
                            );
                            marginTop = gap - underlap;
                        }

                        headingImage.style.marginTop = marginTop + 'px';

                    } else {
                        headingImage.style.marginTop = '2.5rem';
                    }
                }

            }
            for (let headingTitle of headingTitles) {
                if (screenWidth > 1200) {
                    //headingTitle.style.width = titleWidth + 'px';
                    headingTitle.style.width = '100%';
                } else {
                    headingTitle.style.width = '100%';
                }
            }
            for (let headingCta of headingCtas) {

                if(screenWidth > 1400){
                    //headingCta.style.left = ctaWidth + 'px';
                    headingCta.style.top = topPosition + 'px';
                    headingCta.style.paddingTop = 0;
                }
                else if (screenWidth > 1200) {
                    //headingCta.style.left = ctaWidth + 'px';
                    headingCta.style.top = topPosition + 'px';
                    headingCta.style.paddingTop = 0;
                } else {
                    headingCta.style.position = 'relative';
                    headingCta.style.paddingTop ='2.5rem';
                    headingCta.style.top =0;
                    headingCta.style.left = 0;
                }
            }
        }

    });
}